import { makeStyles, createStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import classNames from 'classnames';

const useStyles = makeStyles(() => {
  return createStyles({
    WrapperTitle: {
      justifyContent: 'space-between',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
  });
});

interface SectionTitleDetailProps {
  title: string;
}

const SectionTitleDescription = ({ title }: SectionTitleDetailProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.WrapperTitle, 'pmi-py-4 pmi-my-3')}>
      <Typography gutterBottom variant="h5" component="h2" color="secondary">
        {title}
      </Typography>
    </div>
  );
};
SectionTitleDescription.displayName = 'Group detail component';

export default SectionTitleDescription;
